import { createSlice } from "@reduxjs/toolkit";

const photoModalSlice = createSlice({
  name: "photoModal",
  initialState: {
    isPhotoModalOpen: false,
  },
  reducers: {
    openPhotoModal: (state) => {
      //console.log("open photoModal");
      state.isPhotoModalOpen = true;
    },
    closePhotoModal: (state) => {
      //console.log("close photoModal");
      state.isPhotoModalOpen = false;
    },
  },
});

export const { openPhotoModal, closePhotoModal } = photoModalSlice.actions;
export default photoModalSlice.reducer;
